import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import NIconDark from '../../assets/img/icon/n-icon-dark.svg';
import NIcon from '../../assets/img/icon/n-icon.svg';
import CustomerValue from '../../assets/img/icon/value-1.svg';
import QualityValue from '../../assets/img/icon/value-2.svg';
import SuccessValue from '../../assets/img/icon/value-3.svg';
import TrustValue from '../../assets/img/icon/value-4.svg';
import InnovatorValue from '../../assets/img/icon/value-5.svg';
import Style from './style.module.scss';

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO pageKey="about" />
      <PageHeader title={t('aboutTitle')} />
      <section className={clsx(Style.section, Style.shapeBg)}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('aboutPage.title')}</h2>
            <div className={Style.aboutText}>
              <p>{t('aboutPage.whoWeAre.p1')}</p>
              <p>{t('aboutPage.whoWeAre.p2')}</p>
              <p>{t('aboutPage.whoWeAre.p3')}</p>
              <p>{t('aboutPage.whoWeAre.p4')}</p>
              <p>{t('aboutPage.whoWeAre.p5')}</p>
              <p>{t('aboutPage.whoWeAre.p6')}</p>
              <p>{t('aboutPage.whoWeAre.p7')}</p>
              <p>{t('aboutPage.whoWeAre.p8')}</p>
              <p>{t('aboutPage.whoWeAre.p9')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.yellowBg)}>
        <div className={Style.container}>
          <div className={Style.imageWrapper}>
            <img src={'./assets/img/about-vision.png'} alt={t('aboutPage.vision.title')} />
          </div>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('aboutPage.vision.title')}</h2>
            <div className={Style.visionText}>
              <p>
                <img src={NIconDark} alt="nGaming-icon" />
                {t('aboutPage.vision.p1')}
              </p>
              <p>
                <img src={NIconDark} alt="nGaming-icon" />
                {t('aboutPage.vision.p2')}
              </p>
              <p>
                <img src={NIconDark} alt="nGaming-icon" />
                {t('aboutPage.vision.p3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.darkBg)}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('aboutPage.mission.title')}</h2>
            <div className={Style.missionText}>
              <p>
                <img src={NIcon} alt="nGaming-icon" />
                {t('aboutPage.mission.p1')}
              </p>
              <p>
                <img src={NIcon} alt="nGaming-icon" />
                {t('aboutPage.mission.p2')}
              </p>
              <p>
                <img src={NIcon} alt="nGaming-icon" />
                {t('aboutPage.mission.p3')}
              </p>
            </div>
          </div>
          <div className={Style.imageWrapper}>
            <img src={'./assets/img/about-mission.png'} alt={t('aboutPage.vision.title')} />
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.values)}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('aboutPage.values.title')}</h2>
            <div className={Style.valueWrapper}>
              <div className={Style.valueItem}>
                <img src={CustomerValue} alt={t('aboutPage.values.box1.title')} />
                <div className={Style.value}>
                  <h4 className={Style.valueTitle}>{t('aboutPage.values.box1.title')}</h4>
                  <p className={Style.valueText}>{t('aboutPage.values.box1.description')}</p>
                </div>
              </div>
              <div className={Style.valueItem}>
                <img src={QualityValue} alt={t('aboutPage.values.box2.title')} />
                <div className={Style.value}>
                  <h4 className={Style.valueTitle}>{t('aboutPage.values.box2.title')}</h4>
                  <p className={Style.valueText}>{t('aboutPage.values.box2.description')}</p>
                </div>
              </div>
              <div className={Style.valueItem}>
                <img src={SuccessValue} alt={t('aboutPage.values.box3.title')} />
                <div className={Style.value}>
                  <h4 className={Style.valueTitle}>{t('aboutPage.values.box3.title')}</h4>
                  <p className={Style.valueText}>{t('aboutPage.values.box3.description')}</p>
                </div>
              </div>
              <div className={Style.valueItem}>
                <img src={TrustValue} alt={t('aboutPage.values.box4.title')} />
                <div className={Style.value}>
                  <h4 className={Style.valueTitle}>{t('aboutPage.values.box4.title')}</h4>
                  <p className={Style.valueText}>{t('aboutPage.values.box4.description')}</p>
                </div>
              </div>
              <div className={Style.valueItem}>
                <img src={InnovatorValue} alt={t('aboutPage.values.box5.title')} />
                <div className={Style.value}>
                  <h4 className={Style.valueTitle}>{t('aboutPage.values.box5.title')}</h4>
                  <p className={Style.valueText}>{t('aboutPage.values.box5.description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
